import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { allProducts } from "../Data/catalog";
import { addToCart, getCartItems } from "../Helper/cart";
import "./ProductDetailPage.scss";

function ProductDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const product = useMemo(
    () => allProducts.find((item) => item.id === Number(id)),
    [id]
  );

  const [cartCount, setCartCount] = useState(
    getCartItems().reduce((sum: any, item: any) => sum + item.quantity, 0)
  );

  if (!product) {
    return <div className="container">Product not found.</div>;
  }

  const handleAddToCart = () => {
    const updated = addToCart(product);
    setCartCount(updated.reduce((sum: any, item: any) => sum + item.quantity, 0));
  };

  return (
    <section className="product-detail-page">
      <div className="container">
        <div className="product-detail-layout">
          <div className="product-detail-image">
            <img src={product.imgSrc} alt={product.title} />
          </div>

          <div className="product-detail-info">
            <span className="product-detail-brand">{product.brand}</span>
            <h1>{product.title}</h1>
            <div className="product-detail-price">{product.price}</div>

            <p className="product-detail-desc">
              Premium product listing page for your store. You can later replace
              this with full specs, warranty, stock, and shipping details.
            </p>

            <div className="product-detail-actions">
              <button type="button" className="add-cart-btn" onClick={handleAddToCart}>
                <i className="fa-solid fa-cart-shopping" aria-hidden="true"></i>
                Add to Cart
              </button>

              <button
                type="button"
                className="buy-now-btn"
                onClick={() => {
                  handleAddToCart();
                  navigate("/cart-summary");
                }}
              >
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="floating-cart-btn"
        onClick={() => navigate("/cart-summary")}
      >
        <i className="fa-solid fa-cart-shopping" aria-hidden="true"></i>
        <span className="floating-cart-label">Cart</span>
        {cartCount > 0 && <span className="floating-cart-count">{cartCount}</span>}
      </button>
    </section>
  );
}

export default ProductDetailPage;